import catalog from './pricing-config.json';
export { catalog };
export const money = (cents) =>
  new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: cents % 100 ? 2 : 0,
    maximumFractionDigits: 2,
  })
    .formatToParts(cents / 100)
    .map(({ type, value }) => {
      if (type === 'group') return ',';
      if (type === 'decimal') return '.';
      if (type === 'literal') return '';
      return value;
    })
    .join('');
export const number = (n) => new Intl.NumberFormat('en-ZA').format(n).replace(/\s/g, ',');
export const gross = (cents, vatRate = 0.15) => {
  if (
    !Number.isSafeInteger(cents) ||
    cents < 0 ||
    !Number.isFinite(vatRate) ||
    vatRate < 0 ||
    vatRate > 1
  )
    throw new Error('Invalid tax input');
  const basisPoints = Math.round(vatRate * 10000);
  if (!Number.isSafeInteger(cents * (10000 + basisPoints) + 5000))
    throw new Error('Amount exceeds safe range');
  return Math.floor((cents * (10000 + basisPoints) + 5000) / 10000);
};
export function quote({
  planId = 'deliver',
  annual = false,
  learners = 100,
  creators = 3,
  facilitators = 3,
  vatRate = 0.15,
}) {
  const plan = catalog.plans.find((p) => p.id === planId);
  if (!plan) throw new Error('Unknown plan');
  for (const n of [learners, creators, facilitators])
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('Use a non-negative whole number.');
  if (planId === 'create' && creators > 1)
    throw new Error('Additional creators require Create Teams or above.');
  if (learners > 2000) return { requiresQuote: true };
  if (!['deliver', 'impact'].includes(planId) && (learners || facilitators))
    throw new Error('This plan does not include learner delivery.');
  const baseCents = Math.round(
    (annual ? plan.annualMonthlyEquivalentZar : plan.monthlyBaseZar) * 100,
  );
  const learnerCents =
    3500 * Math.max(0, Math.min(learners, 500) - plan.includedMonthlyActiveLearners) +
    2500 * Math.max(0, learners - 500);
  const creatorCents = 65000 * Math.max(0, creators - plan.includedCreators);
  const facilitatorCents = 25000 * Math.max(0, facilitators - plan.includedFacilitators);
  const netCents = baseCents + learnerCents + creatorCents + facilitatorCents;
  return {
    requiresQuote: false,
    baseCents,
    learnerCents,
    creatorCents,
    facilitatorCents,
    netCents,
    grossCents: gross(netCents, vatRate),
    annualBaseCents: Math.round(plan.annualBaseZar * 100),
  };
}
